import { Component, OnInit, Input } from '@angular/core';
import { Desenvolvedor } from 'src/app/desenvolvedor/desenvolvedor';
import { Router } from '@angular/router';


@Component({
  selector: 'store-desenvolvido-por',
  templateUrl: './desenvolvido-por.component.html',
  styleUrls: ['./desenvolvido-por.component.scss']
})
export class DesenvolvidoPorComponent implements OnInit {

  @Input()
  public desenvolvidoPor: Desenvolvedor;

  constructor(private router: Router) { }

  ngOnInit() {
    // TODO: Remover essa regra quando a api estiver retornando corretamente
    this.desenvolvidoPor.site = !!this.desenvolvidoPor.site && !this.desenvolvidoPor.site.startsWith('http')
    ? `http://${this.desenvolvidoPor.site}` : this.desenvolvidoPor.site;
  }

  getDesenvolvedor(id) {
    this.router.navigate(['desenvolvedor/' + id]);
  }

}
